export const dadosPlanoDefault = {
  titulo: '',
  valorMensal: '',
  quantidadeAdicional: '',
  valorAdicionalBeneficiario: '',
  valorAdicionalDependente: '',
};

export const notificationDefault = {
  variant: '',
  message: '',
  isOpen: false,
};
